import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const MenuSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M2.6615 17.0855H21.3298C21.7019 17.0855 22 16.7913 22 16.4153C22 16.0431 21.7019 15.745 21.3298 15.745H2.6615C2.29813 15.745 2 16.0431 2 16.4153C2 16.7913 2.29813 17.0855 2.6615 17.0855ZM2.6615 12.6704H21.3298C21.7019 12.6704 22 12.3722 22 12.0001C22 11.628 21.7019 11.3299 21.3298 11.3299H2.6615C2.29813 11.3299 2 11.628 2 12.0001C2 12.3722 2.29813 12.6704 2.6615 12.6704ZM2.6615 8.24645H21.3298C21.7019 8.24645 22 7.94835 22 7.58497C22 7.21287 21.7019 6.91473 21.3298 6.91473H2.6615C2.29813 6.91473 2 7.21287 2 7.58497C2 7.94835 2.29813 8.24645 2.6615 8.24645Z"
        fill={color}
      />
    </svg>
  );
};

export { MenuSvg };
